// extracted by mini-css-extract-plugin
export default {"container":"Game_container__F+JG7","choices":"Game_choices__pGgzm","button":"Game_button__HOFRE","results":"Game_results__e-hVW"};